import ReactFlow, {
  Background,
  Controls,
  Edge,
  Handle,
  Node,
  Position,
  useEdgesState,
  useNodes,
  useNodesInitialized,
  useNodesState,
  useReactFlow,
  useStore,
  useStoreApi,
} from "reactflow";
import "reactflow/dist/style.css";
import { Graph } from "./graph";
import assert from "assert";
import React, { useCallback, useState } from "react";
import { InterpType } from "../interpretation/interpretable";
import { AssignmentNode } from "./components/assignment_node";
import { IfNode } from "./components/if_node";
import { EndIfNode } from "./components/end_if_node";
import useAutoLayout from "./layout";
import { Draggable } from "./dragdrop";
import { ForLoop } from "./components/for_loop_node";
import { EndForNode } from "./components/end_for";

const defaultViewport = { x: 0, y: 0, zoom: 1.5 };

const nodeTypes = {};
nodeTypes[InterpType.Assignment] = AssignmentNode;
nodeTypes[InterpType.If] = IfNode;
nodeTypes[InterpType.If + "-end"] = EndIfNode;
nodeTypes[InterpType.ForLoop] = ForLoop;
nodeTypes[InterpType.ForLoop + "-end"] = EndForNode;
nodeTypes[InterpType.ForIter] = ForLoop;
nodeTypes[InterpType.ForIter + "-end"] = EndForNode;

const MIN_DISTANCE = 150;

export function FlowchartComponent(props: { graph: Graph; locked?: boolean }) {
  const [nodes, setNodes, onc] = useNodesState([]);
  const [edges, setEdges, oec] = useEdgesState([]);
  const [changeFlag, setChangeFlag] = useState(false);
  const store = useStoreApi();

  useAutoLayout(
    {
      direction: "TB",
    },
    changeFlag
  );
  
  /**
   * Our flowchart supports nodes of a variable length, but we need ReactFlow to compute the length
   * before we can set positions. So, this function is called 3 times per change:
   * - 1. set the nodes and edges for next render,
   * - 2. render the nodes and edges, getting the width and height of the nodes
   * - 3. set the nodes position.
   * see https://github.com/xyflow/xyflow/issues/991
   */

  // STEP 1: (don't render anything here, just change the state)
  if (props.graph.hasChanged()) {
    console.log("changing graph");
    setNodes(Array.from(props.graph.getNodes()));
    setEdges(Array.from(props.graph.getEdges()));
    setChangeFlag(!changeFlag);
    return <></>;
  }


  return (
    <>
      <ReactFlow
        className="validationflow"
        nodes={nodes}
        edges={edges}
        onNodesChange={(e) => {if(!props.locked) {onc(e)}}}
        onEdgesChange={oec}
        nodeTypes={nodeTypes}
        proOptions={{ hideAttribution: true }}
        panOnScroll={true}
        defaultViewport={defaultViewport}
        nodesDraggable={!props.locked}
        draggable={!props.locked}
        panOnDrag={!props.locked}
      >
        <Background></Background>
        <Controls></Controls>
      </ReactFlow>
    </>
  );
}
